import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { getProfileById } from "../../actions/profile";
import { connect } from "react-redux";
import ProfileItem from "./ProfileItem";

// This Component is not being used currently
const Profile = ({
  match,
  getProfileById,
  profile: { profile, loading },
  auth,
}) => {
  useEffect(() => {
    getProfileById(match.params.id);
  }, [getProfileById, match.params.id]);

  return (
    <>
      {profile === null && loading ? (
        <img
          src={require("../../images/load.gif")}
          alt='Loading . . . '
          className='load'
        />
      ) : (
        <ProfileItem profile={profile} user={profile.user} />
      )}
    </>
  );
};

Profile.propTypes = {
  getProfileById: PropTypes.func.isRequired,
  auth: PropTypes.object.isRequired,
  profile: PropTypes.object.isRequired,
  user: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  auth: state.auth,
  user: state.user,
});

export default connect(mapStateToProps, { getProfileById })(Profile);
